'use client';

import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["width", "height", "margin", "children", "series", "colors", "dataset", "desc", "onAxisClick", "highlightedAxis", "onHighlightedAxisChange", "tooltipItem", "onTooltipItemChange", "disableVoronoi", "voronoiMaxRadius", "onItemClick", "disableAxisListener", "highlightedItem", "onHighlightChange", "sx", "title", "xAxis", "yAxis", "zAxis", "rotationAxis", "radiusAxis", "skipAnimation", "seriesConfig", "plugins", "localeText", "slots", "slotProps", "experimentalFeatures", "enableKeyboardNavigation", "brushConfig", "onHiddenItemsChange", "hiddenItems", "initialHiddenItems"];
import { DEFAULT_PLUGINS } from "../internals/plugins/allPlugins.js";
export const useChartContainerProps = (props, ref) => {
  const _ref = props,
    {
      width,
      height,
      margin,
      children,
      series,
      colors,
      dataset,
      desc,
      onAxisClick,
      highlightedAxis,
      onHighlightedAxisChange,
      tooltipItem,
      onTooltipItemChange,
      disableVoronoi,
      voronoiMaxRadius,
      onItemClick,
      disableAxisListener,
      highlightedItem,
      onHighlightChange,
      sx,
      title,
      xAxis,
      yAxis,
      zAxis,
      rotationAxis,
      radiusAxis,
      skipAnimation,
      seriesConfig,
      plugins,
      localeText,
      slots,
      slotProps,
      experimentalFeatures,
      enableKeyboardNavigation,
      brushConfig,
      onHiddenItemsChange,
      hiddenItems,
      initialHiddenItems
    } = _ref,
    other = _objectWithoutPropertiesLoose(_ref, _excluded);
  const chartsSurfaceProps = _extends({
    title,
    desc,
    sx,
    ref
  }, other);
  const chartDataProviderProps = {
    margin,
    series,
    colors,
    dataset,
    disableAxisListener,
    highlightedItem,
    onHighlightChange,
    onAxisClick,
    highlightedAxis,
    onHighlightedAxisChange,
    tooltipItem,
    onTooltipItemChange,
    disableVoronoi,
    voronoiMaxRadius,
    onItemClick,
    xAxis,
    yAxis,
    zAxis,
    rotationAxis,
    radiusAxis,
    skipAnimation,
    width,
    height,
    localeText,
    seriesConfig,
    experimentalFeatures,
    enableKeyboardNavigation,
    brushConfig,
    onHiddenItemsChange,
    hiddenItems,
    initialHiddenItems,
    plugins: plugins ?? DEFAULT_PLUGINS,
    slots,
    slotProps
  };
  return {
    chartDataProviderProps,
    chartsSurfaceProps,
    children
  };
};